import { Box, Text, TextField } from "@radix-ui/themes";
import { IntegrationDefinition } from "@/types/breeze/Integration";

const sectionStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  padding: 16,
  borderRadius: 8,
  border: "1px solid var(--gray-5)",
  backgroundColor: "var(--gray-2)",
  display: "flex",
  flexDirection: "column",
  gap: 12,
};

interface ApiKeyConfigFormProps {
  definition: IntegrationDefinition;
  apiKey: string;
  onApiKeyChange: (s: string) => void;
}

export function ApiKeyConfigForm({
  definition,
  apiKey,
  onApiKeyChange,
}: ApiKeyConfigFormProps) {
  return (
    <Box style={sectionStyle}>
      <Text size="1" color="gray" style={{ display: "block" }}>
        {definition.display_name} authenticates each request with a secret
        key issued by the provider. Stored encrypted; never displayed again
        after saving.
      </Text>
      <Box>
        <Text size="2" weight="medium" mb="1">
          API key
        </Text>
        <TextField.Root
          type="password"
          value={apiKey}
          onChange={(e) => onApiKeyChange(e.target.value)}
          placeholder="sk-..."
        />
      </Box>
    </Box>
  );
}
